import './DataTableColumnsList.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var noItemsFound = '_14dz1ui0-3-5-0';
export var virtualizationInnerContainer = '_14dz1ui4-3-5-0';
export var virtualizationScrollContainer = _7a468({defaultClassName:'_14dz1ui1-3-5-0',variantClassNames:{hasFilter:{true:'_14dz1ui2-3-5-0',false:'_14dz1ui3-3-5-0'}},defaultVariants:{hasFilter:false},compoundVariants:[]});